import React from 'react';
import {Tooltip} from '../../Tooltip/index';
import {TooltipPosition} from '../../Tooltip/types';

export interface WithTooltipProps {
    tooltip?: React.ReactNode;
    position?: TooltipPosition;
    inverted?: boolean;
    tooltipClassname?: string;
    wrapperClassname?: string;
    children?: JSX.Element;
    delay?: number;
}

export const withTooltip = <P extends object>(Component: React.ComponentType<P>) => {
    return (props: WithTooltipProps & P) => {
        return (
            <Tooltip {...props} className={props.tooltipClassname}>
                <Component {...props} />
            </Tooltip>
        );
    };
};
